import React from 'react';
import PropTypes from 'prop-types';
import Modal from '../../../../commonComponents/modal/Modal';
import ModalHeader from '../../../../commonComponents/modal/ModalHeader';
import ModalFooter from '../../../../commonComponents/modal/ModalFooter';
import { compose } from '../../../../services/utilityFunctions';
import translate from '../../../../commonComponents/translate';
import withCSRF from '../../../../commonComponents/withCSRF';

function UnlockUserPageNameModal({ t, onClose, onSave }) {
  return (
    <Modal onClose={onClose}>
      <div className="modal-dialog">
        <div className="modal-content">
          <ModalHeader
            title={t('modal.userPageName.title')}
            onClose={onClose}
          />
          <div className="modal-body">
            <div className="container-fluid">
              <div className="row">
                <div className="portlet-body form">
                  <p style={{ paddingLeft: '20px' }}>
                    {t('modal.userPageName.content')}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <ModalFooter
            onSave={onSave}
            onCancel={onClose}
            saveText={t('unlock')}
            cancelText={t('cancel')}
          />
        </div>
      </div>
    </Modal>
  );
}

UnlockUserPageNameModal.propTypes = {
  t: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
};

export default compose(translate, withCSRF)(UnlockUserPageNameModal);
